import { useEffect } from "react";
import { LOGO_LIGHT_DATA } from "./assets.js";

const ShareCardPeriod = ({ summary, medal }) => {
  useEffect(() => {
    const link = document.createElement("link");
    link.href = "https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700;800;900&family=Nunito+Sans:wght@400;600&display=swap";
    link.rel = "stylesheet";
    document.head.appendChild(link);
  }, []);

  const isWeekly = summary?.type === "weekly";

  // Volume formaté
  const volRaw = summary?.volume || 0;
  const volStr = volRaw >= 1000
    ? (volRaw / 1000).toFixed(1) + "T"
    : Math.round(volRaw) + "kg";

  // Temps formaté
  const totalTime = summary?.totalTime || 0;
  const timeStr = totalTime >= 60
    ? `${Math.floor(totalTime / 60)}h${String(totalTime % 60).padStart(2, "0")}`
    : `${totalTime}min`;

  // PR détaillés sur la période
  const newPRs = summary?.newPRs || []; // [{ name, weight }]

  // Label période
  const periodLabel = summary?.label || "";

  const stats = [
    { label: "Séances",     value: String(summary?.totalSessions || 0) },
    { label: "Jours actifs", value: String(summary?.activeDays || 0) },
    { label: "Volume",      value: volStr },
    { label: "Temps total", value: timeStr },
  ];

  return (
    <div style={{
      width: 390,
      height: 693,
      overflow: "hidden",
      position: "relative",
      background: "#080808",
      display: "flex",
      flexDirection: "column",
      fontFamily: "'Nunito', sans-serif",
    }}>

      {/* ── NOISE TEXTURE ── */}
      <svg style={{ position: "absolute", width: 0, height: 0 }}>
        <filter id="noise-period">
          <feTurbulence type="fractalNoise" baseFrequency="0.75" numOctaves="4" stitchTiles="stitch" />
          <feColorMatrix type="saturate" values="0" />
          <feBlend in="SourceGraphic" mode="overlay" />
        </filter>
      </svg>
      <div style={{
        position: "absolute", inset: 0, zIndex: 0,
        filter: "url(#noise-period)", opacity: 0.035, background: "#fff",
      }} />

      {/* ── FOND gradient ── */}
      <div style={{
        position: "absolute", inset: 0, zIndex: 0,
        background: `
          radial-gradient(ellipse 60% 35% at 85% 10%, rgba(212,175,55,0.22) 0%, transparent 70%),
          radial-gradient(ellipse 50% 30% at 15% 90%, rgba(180,140,30,0.18) 0%, transparent 65%),
          linear-gradient(175deg, #14110A 0%, #0A0805 40%, #060503 100%)
        `,
      }} />

      {/* ── FILIGRANE géométrique ── */}
      <div style={{
        position: "absolute", top: "50%", left: "50%",
        transform: "translate(-50%, -50%)",
        width: 300, height: 300, zIndex: 0,
        borderRadius: "50%",
        border: "1px solid rgba(212,175,55,0.1)",
        boxShadow: "0 0 0 40px rgba(212,175,55,0.05), 0 0 0 80px rgba(212,175,55,0.03)",
      }} />
      <div style={{
        position: "absolute", top: "50%", left: "50%",
        transform: "translate(-50%, -50%) rotate(45deg)",
        width: 200, height: 200, zIndex: 0,
        border: "1px solid rgba(212,175,55,0.08)",
      }} />

      {/* ── BANDE OR haut ── */}
      <div style={{
        position: "absolute", top: 0, left: 0, right: 0, height: 2, zIndex: 2,
        background: "linear-gradient(90deg, transparent 0%, rgba(212,175,55,0.98) 30%, #D4AF37 50%, rgba(212,175,55,0.98) 70%, transparent 100%)",
      }} />

      {/* ── HEADER : LOGO/MÉDAILLE + BEARFORGE ── */}
      <div style={{
        position: "relative", zIndex: 1,
        display: "flex", alignItems: "center", justifyContent: "space-between",
        padding: "28px 28px 0",
      }}>
        <div style={{
          width: 66, height: 66, borderRadius: "50%",
          background: "linear-gradient(135deg, rgba(212,175,55,0.22) 0%, rgba(160,120,20,0.2) 100%)",
          border: "1px solid rgba(212,175,55,0.55)",
          display: "flex", alignItems: "center", justifyContent: "center",
          boxShadow: "0 0 16px rgba(212,175,55,0.22)",
          overflow: "hidden",
        }}>
          <img
            src={medal?.img || LOGO_LIGHT_DATA}
            alt={medal?.label || "Calestan"}
            style={{ width: 52, height: 52, objectFit: "contain" }}
          />
        </div>

        <div style={{ textAlign: "right" }}>
          <div style={{
            color: "#D4AF37", fontSize: 15, fontWeight: 800,
            letterSpacing: "5px", fontFamily: "'Nunito', sans-serif",
            textTransform: "uppercase",
          }}>Calestan</div>
        </div>
      </div>

      {/* ── DIVIDER or ── */}
      <div style={{
        position: "relative", zIndex: 1,
        margin: "20px 28px 0",
        display: "flex", alignItems: "center", gap: 10,
      }}>
        <div style={{ flex: 1, height: 1, background: "linear-gradient(90deg, transparent, rgba(212,175,55,0.6))" }} />
        <div style={{ width: 5, height: 5, background: "#D4AF37", transform: "rotate(45deg)" }} />
        <div style={{ flex: 1, height: 1, background: "linear-gradient(90deg, rgba(212,175,55,0.6), transparent)" }} />
      </div>

      {/* ── LABEL ── */}
      <div style={{ position: "relative", zIndex: 1, textAlign: "center", marginTop: 18 }}>
        <div style={{
          display: "inline-block",
          color: "rgba(212,175,55,0.85)", fontSize: 10, letterSpacing: "5px",
          fontFamily: "'Nunito', sans-serif", textTransform: "uppercase",
          fontWeight: 600, borderBottom: "1px solid rgba(212,175,55,0.4)", paddingBottom: 5,
        }}>{isWeekly ? "Récap de la semaine" : "Récap du mois"}</div>
      </div>

      {/* ── PÉRIODE ── */}
      <div style={{
        position: "relative", zIndex: 1,
        textAlign: "center", padding: "10px 24px 0",
      }}>
        <div style={{
          color: "#FFF0B0", fontSize: 22, fontWeight: 900,
          fontFamily: "'Nunito', sans-serif", textTransform: "uppercase",
          letterSpacing: "2px",
          textShadow: "0 0 40px rgba(212,175,55,0.5), 0 2px 20px rgba(0,0,0,0.8)",
        }}>{periodLabel}</div>
        {medal && (
          <div style={{
            color: "rgba(212,175,55,0.7)", fontSize: 11, marginTop: 5,
            fontFamily: "'Nunito', sans-serif", letterSpacing: "2px",
            fontWeight: 700, textTransform: "uppercase",
          }}>Médaille {medal.label}</div>
        )}
      </div>

      {/* ── GRILLE 2×2 STATS ── */}
      <div style={{
        position: "relative", zIndex: 1,
        display: "grid", gridTemplateColumns: "1fr 1fr",
        margin: "18px 22px 0", gap: 1,
      }}>
        {stats.map((st, i) => {
          const isTop = i < 2;
          const isLeft = i % 2 === 0;
          return (
            <div key={i} style={{
              padding: "16px 10px 14px",
              textAlign: "center",
              borderTop: isTop ? "1px solid rgba(212,175,55,0.55)" : "1px solid rgba(212,175,55,0.25)",
              borderBottom: !isTop ? "1px solid rgba(212,175,55,0.55)" : "1px solid rgba(212,175,55,0.25)",
              borderLeft: isLeft ? "1px solid rgba(212,175,55,0.35)" : "none",
              borderRight: !isLeft ? "1px solid rgba(212,175,55,0.35)" : "none",
              background: (i === 0 || i === 3)
                ? "linear-gradient(180deg, rgba(212,175,55,0.1) 0%, rgba(180,148,80,0.03) 100%)"
                : "transparent",
              position: "relative",
            }}>
              {/* séparateur vertical */}
              {isLeft && (
                <div style={{
                  position: "absolute", right: 0, top: "20%", bottom: "20%", width: 1,
                  background: "linear-gradient(180deg, transparent, rgba(212,175,55,0.45), transparent)",
                }} />
              )}
              {/* séparateur horizontal */}
              {isTop && (
                <div style={{
                  position: "absolute", bottom: 0, left: "10%", right: "10%", height: 1,
                  background: "linear-gradient(90deg, transparent, rgba(212,175,55,0.35), transparent)",
                }} />
              )}
              <div style={{
                color: "#D4AF37", fontSize: 24, fontWeight: 900,
                fontFamily: "'Nunito', sans-serif", letterSpacing: "1px", lineHeight: 1,
              }}>{st.value}</div>
              <div style={{
                color: "rgba(212,175,55,0.75)", fontSize: 9, letterSpacing: "2.5px",
                marginTop: 6, textTransform: "uppercase",
                fontFamily: "'Nunito', sans-serif", fontWeight: 600,
              }}>{st.label}</div>
            </div>
          );
        })}
      </div>

      {/* ── PR SECTION ── */}
      <div style={{
        position: "relative", zIndex: 1,
        margin: "14px 22px 0",
        border: "1px solid rgba(212,175,55,0.35)",
        borderRadius: 4,
        padding: "12px 16px",
        background: "linear-gradient(135deg, rgba(212,175,55,0.08) 0%, rgba(100,80,10,0.06) 100%)",
      }}>
        {newPRs.length === 0 ? (
          <div style={{
            color: "rgba(212,175,55,0.5)", fontSize: 11,
            fontFamily: "'Nunito', sans-serif", fontWeight: 600,
            letterSpacing: "1px", textAlign: "center",
            textTransform: "uppercase",
          }}>Aucun PR sur cette période</div>
        ) : newPRs.length === 1 ? (
          <div style={{
            color: "#D4AF37", fontSize: 12, fontWeight: 700,
            fontFamily: "'Nunito', sans-serif", letterSpacing: "0.5px",
            textAlign: "center",
          }}>
            Nouveau PR — {newPRs[0].name} : {newPRs[0].weight} kg
          </div>
        ) : (
          <>
            <div style={{
              color: "#D4AF37", fontSize: 10, fontWeight: 800,
              letterSpacing: "3px", textTransform: "uppercase",
              fontFamily: "'Nunito', sans-serif", marginBottom: 6,
            }}>Nouveaux PR</div>
            {newPRs.slice(0, 4).map((pr, i) => (
              <div key={i} style={{
                color: "rgba(255,215,0,0.85)", fontSize: 11,
                fontFamily: "'Nunito', sans-serif", fontWeight: 600,
                lineHeight: 1.6,
              }}>— {pr.name} : {pr.weight} kg</div>
            ))}
            {newPRs.length > 4 && (
              <div style={{
                color: "rgba(212,175,55,0.5)", fontSize: 10,
                fontFamily: "'Nunito', sans-serif", marginTop: 2,
              }}>+ {newPRs.length - 4} autres</div>
            )}
          </>
        )}
      </div>

      {/* SPACER */}
      <div style={{ flex: 1 }} />

      {/* ── FOOTER ── */}
      <div style={{ position: "relative", zIndex: 1, marginTop: 16 }}>
        <div style={{
          height: 1,
          background: "linear-gradient(90deg, transparent, rgba(212,175,55,0.5) 30%, rgba(212,175,55,0.5) 70%, transparent)",
        }} />
        <div style={{
          textAlign: "center", padding: "12px 0 18px",
          display: "flex", alignItems: "center", justifyContent: "center", gap: 10,
        }}>
          <div style={{ width: 20, height: 1, background: "rgba(212,175,55,0.5)" }} />
          <div style={{
            color: "rgba(212,175,55,0.6)", fontSize: 9, letterSpacing: "3.5px",
            fontFamily: "'Nunito', sans-serif", textTransform: "uppercase", fontWeight: 600,
          }}>calestan.fr</div>
          <div style={{ width: 20, height: 1, background: "rgba(212,175,55,0.5)" }} />
        </div>
      </div>

      {/* ── BANDE OR BAS ── */}
      <div style={{
        position: "absolute", bottom: 0, left: 0, right: 0, height: 2, zIndex: 2,
        background: "linear-gradient(90deg, transparent 0%, rgba(212,175,55,0.82) 30%, #D4AF37 50%, rgba(212,175,55,0.82) 70%, transparent 100%)",
      }} />

    </div>
  );
};

export { ShareCardPeriod };
export default ShareCardPeriod;
